import billLogApi from '@/api/billLog/billLogApi'


export default {
    name: 'bill-log-get-bill-success',
    mixins: [],
    extends: {},
    components: {},
    props: [],
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    created() {

    },
    mounted() {
        this.init();
    },
    updated() {},
    beforeDestroy() {},
    methods: {
        async init() {
            let confirmCode = this.$route.query.code;
            let res = await billLogApi.sendDetailBillEMail(confirmCode);
            // console.log('res=', res);
            // if (!res) {
            //     this.$router.push('error');
            // }
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/billLog/billLogGetBillSuccess.js